<template>
  <div>
    <v-dialog 
      v-model="value" 
      max-width="400"
      @keydown.esc="this.$emit('input' , false)"
      @click:outside="$emit('input', false)"
    >
      <v-form
        @submit.prevent="saveAreaAccounting()"
        ref="form"
        :lazy-validation="true"
        :disabled="isLoading"
      >
        <v-card v-if="accountingProduct">
          <v-card-title>
            <v-icon left>mdi-pencil</v-icon> {{ accountingProduct.name }}
          </v-card-title>
          <v-card-text class="pt-2">
            <p class="mb-1">{{ $t('price') }}</p>
            <v-currency-field
              flat
              solo
              background-color="grey lighten-3"
              :label="$t('price')"
              class="input-disable-appearance"
              :placeholder="$t('price')"
              v-model="formData.cost"
              :rules="[rules.required]"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="isLoading"
              color="error"
              elevation="0"
              @click.native="$emit('input' , false)"
              >{{ $t('cancel') }}</v-btn
            >
            <v-btn
              :loading="isLoading"
              color="primary"
              elevation="0"
              type="submit"
              :disabled="!formData.accountingProductId || !formData.cost ? true : false || isLoading"
              >{{ $t('save') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar v-model="isError" color="error">
      {{ $t('validate.error_add_market_area') }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    value: Boolean,
    marketId: String,
    projectId: String,
    area: Object,
    areaAccountingProduct: Object,
    areaAccountingProducts: Array,
    accountingProduct: Object,
  },
  computed: {
    ...mapState({
      accountingProducts: (state) => state.accountingProducts.accountingProducts,
    }),
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('validate.please_input_data'),
      },
      isError: false,
      isLoading: false,
      formData: {},
    };
  },
  watch: {
    value(){
      if (this.$refs.form) this.$refs.form.resetValidation();
      if(this.areaAccountingProduct){
        this.formData = {
          id: this.areaAccountingProduct.objectId,
          accountingProductId: this.areaAccountingProduct.accountingProduct.objectId,
          cost: this.areaAccountingProduct.cost,
        }
      }else{ // edit
        this.formData = {
          areaId: this.area.objectId,
          accountingProductId: this.accountingProduct.objectId,
          cost: null,
        }
      }
    }
  },
  async created() {
    this.isLoading = true;
    try{
      await this.$store.dispatch("accountingProducts/getAccountingProducts", this.projectId)
      this.isLoading = false
    }catch(error){
      this.isError = true;
      this.isLoading = false;
    }
  },
  methods: {
    async saveAreaAccounting() {
      this.isLoading = true;
      try{
        this.formData.cost = parseFloat(this.formData.cost)
        let areaAccountingProduct
        if(this.formData.id){
          areaAccountingProduct = await this.$store.dispatch("areaAccountingProduct/updateAreaAccountingProduct", this.formData)
        }else{
          areaAccountingProduct = await this.$store.dispatch("areaAccountingProduct/createAreaAccountingProduct", this.formData)
        }
        await this.$store.dispatch("areaAccountingProduct/getAreaAccountingProduct", areaAccountingProduct.objectId)
        this.isLoading = false
        this.$emit("onSaveSuccess" , true)
        this.$emit("input" , false)
      }catch(error){
        this.isError = true;
        this.isLoading = false;
      }
    },
    chengeProduct(accountingProductId){
      let areaAccountingProduct = this.areaAccountingProducts.find(d => d.accountingProduct.objectId == this.formData.accountingProductId)
      if(areaAccountingProduct){
        this.formData = {
          id: areaAccountingProduct.objectId,
          accountingProductId: areaAccountingProduct.accountingProduct.objectId,
          cost: areaAccountingProduct.cost,
        }
      }else{
        this.formData = {
          areaId: this.area.objectId,
          accountingProductId: accountingProductId,
          cost: null,
        }
        if (this.$refs.form) this.$refs.form.resetValidation();
      }
    }
  },
};
</script>
